import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col, Card } from 'react-bootstrap';

const Features = ({
  feature1Title = 'Advanced Technology',
  feature1Description = 'We utilize cutting-edge technology to manufacture high-quality industrial machinery that meets the needs of our clients.',
  feature1ImgSrc = 'https://images.pexels.com/photos/8438864/pexels-photo-8438864.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
  feature1ImgAlt = 'Industrial machinery manufacturing process',
  feature2Title = 'Durability',
  feature2Description = 'Our machinery is built to last, ensuring long-term reliability and performance for our customers.',
  feature2ImgSrc = 'https://images.pexels.com/photos/27810157/pexels-photo-27810157/free-photo-of-a-kettlebell-on-a-black-background-with-two-balls.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
  feature2ImgAlt = 'Durable and reliable machinery',
  feature3Title = 'Tailored Solutions',
  feature3Description = 'We offer customized industrial machinery solutions to meet the specific requirements of each client, ensuring optimal efficiency and productivity.',
  feature3ImgSrc = 'https://images.pexels.com/photos/7479031/pexels-photo-7479031.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
  feature3ImgAlt = 'Customized solutions for clients',
}) => {
  const [activeTab, setActiveTab] = useState(0);

  const features = [
    {
      title: feature1Title,
      description: feature1Description,
      imgSrc: feature1ImgSrc,
      imgAlt: feature1ImgAlt,
    },
    {
      title: feature2Title,
      description: feature2Description,
      imgSrc: feature2ImgSrc,
      imgAlt: feature2ImgAlt,
    },
    {
      title: feature3Title,
      description: feature3Description,
      imgSrc: feature3ImgSrc,
      imgAlt: feature3ImgAlt,
    },
  ];

  return (
    <Container fluid className="py-5">
      <Row className="align-items-center">
        <Col md={6} className="text-center">
          {/* Fixed size for the image */}
          <div
            style={{
              width: '100%',
              maxWidth: '500px',
              height: '500px',
              overflow: 'hidden',
              margin: '0 auto',
            }}
          >
            <img
              src={features[activeTab].imgSrc}
              alt={features[activeTab].imgAlt}
              className="img-fluid rounded shadow"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </div>
        </Col>
        <Col md={6}>
          {features.map((feature, index) => (
            <div
              key={index}
              className="d-flex align-items-center mb-3 p-3"
              style={{
                cursor: 'pointer',
                borderLeft: activeTab === index ? '5px solid black' : '5px solid transparent',
                transition: 'all 0.3s ease-in-out',
              }}
              onMouseEnter={() => setActiveTab(index)} // Set active tab on hover
              onMouseLeave={() => setActiveTab(activeTab)} // Keep the hover effect
            >
              <Card className="border-0 w-100">
                <Card.Body>
                  <Card.Title className="fw-bold fs-3">{feature.title}</Card.Title>
                  <Card.Text>{feature.description}</Card.Text>
                </Card.Body>
              </Card>
            </div>
          ))}
        </Col>
      </Row>
    </Container>
  );
};

Features.propTypes = {
  feature1Title: PropTypes.string,
  feature1Description: PropTypes.string,
  feature1ImgSrc: PropTypes.string,
  feature1ImgAlt: PropTypes.string,
  feature2Title: PropTypes.string,
  feature2Description: PropTypes.string,
  feature2ImgSrc: PropTypes.string,
  feature2ImgAlt: PropTypes.string,
  feature3Title: PropTypes.string,
  feature3Description: PropTypes.string,
  feature3ImgSrc: PropTypes.string,
  feature3ImgAlt: PropTypes.string,
};

export default Features;
